/**
 * Global keyboard UI — command palette, module launcher, cheat sheet.
 * Mounted at app root so shortcuts work on firm ERP and platform shells alike.
 */
import { KeyboardCheatSheet } from "@/components/keyboard/KeyboardCheatSheet";
import { ModuleLauncher } from "@/components/keyboard/ModuleLauncher";
import { QuickCommandPalette } from "@/components/layout/QuickCommandPalette";

export function GlobalKeyboardChrome() {
  return (
    <>
      <QuickCommandPalette />
      <KeyboardCheatSheet />
      <ModuleLauncher />
    </>
  );
}
